








































































































import {computed, ComputedRef, defineComponent, PropType, WritableComputedRef, onMounted} from "@vue/composition-api"
import InputAtom from "@/shared/components/atoms/InputAtom.vue"
import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ILabels} from "@/apps/StudentExchangePartnerWidget/models/config-viewmodel"
import {useProgressExchangeBus} from "@/shared/composables/progressExchangeBus"
import {ProgressAction, ProgressToggle} from "@/apps/StudentExchangePartnerWidget/models/progress-enums"

export default defineComponent({
    name: "StudentExchangePartnerWidget",
    components: {ExchangeCard, InputAtom},
    props: {
        labels: {
            type: Object as PropType<ILabels>,
            required: true
        },
        programId: {
            type: Number,
            required: true
        },
        redirectUrl: {
            type: String,
            required: true
        },
        language: {
            type: String,
            required: true
        }
    },
    setup(props: any) {
        const { 
            setSignUp, 
            setInsurance, 
            setPrivacy, 
            setLabels, 
            setProgramId, 
            setRedirectUrl, 
            setLanguage, 
            loadStudyName,
            addStudentExchangePartner 
        } = useActions([
            'setSignUp',
            'setInsurance',
            'setPrivacy',
            'setProgramId',
            'setRedirectUrl',
            'setLabels',
            'setLanguage',
            'loadStudyName',
            'addStudentExchangePartner',
        ])
        const { 
            getLoading, 
            getLabels,
            getSignUp,
            getInsurance, 
            getPrivacy,
            getRedirectUrl, 
            getStudyName,
            getErrorMessage
        } = useGetters([
            'getLoading',
            'getLabels',
            'getSignUp',
            'getInsurance',
            'getPrivacy',
            'getRedirectUrl',
            'getStudyName',
            'getErrorMessage'
        ])
        setLabels(props.labels)
        setRedirectUrl(props.redirectUrl)
        setProgramId(props.programId)
        setLanguage(props.language)
        loadStudyName()
        
        const signup: WritableComputedRef<any> = computed({
            get(): string {
                return getSignUp.value
            },
            set(value: string): void {
                setSignUp(value)
            }
        })

        const insurance: WritableComputedRef<any> = computed({
            get(): any {
                return getInsurance.value
            },
            set(value: boolean): void {
                setInsurance(value)
            }
        })

        const privacy: WritableComputedRef<any> = computed({
            get(): any {
                return getPrivacy.value
            },
            set(value: boolean): void {
                setPrivacy(value)
            }
        })

        const canContinue: ComputedRef = computed((): boolean => {
            return privacy.value && insurance.value && signup.value && !getLoading.value
        })

        function progress(value: string, action: ProgressAction) {
            switch (action) {
                case ProgressAction.ADD:
                    useProgressExchangeBus().progress.push(value)
                    break
                case ProgressAction.REMOVE:
                    useProgressExchangeBus().progress = useProgressExchangeBus().progress.filter(item => item != value)
                    break
            }
        }

        onMounted(() => {
            useProgressExchangeBus().progress.push(getLabels.value.studentExchangeEducationTitle)
        })
        
        function toggle(type: ProgressToggle, value = null) {
            switch (type) {
                case ProgressToggle.SIGNUP:
                    signup.value = value
                    if (value) {
                        progress(getLabels.value.studentExchangeApplicationTitle, ProgressAction.ADD)
                    } else {
                        progress(getLabels.value.studentExchangeApplicationTitle, ProgressAction.REMOVE)
                    }
                    break
                case ProgressToggle.INSURANCE:
                    insurance.value = !insurance.value
                    if (insurance.value) {
                        progress(getLabels.value.crisisInsuranceTitle, ProgressAction.ADD)
                    } else {
                        progress(getLabels.value.crisisInsuranceTitle, ProgressAction.REMOVE)
                    }
                    break
                case ProgressToggle.PRIVACY:
                    privacy.value = !privacy.value
                    if(privacy.value) {
                        progress(getLabels.value.privacyStatementTitle, ProgressAction.ADD)
                    } else {
                        progress(getLabels.value.privacyStatementTitle, ProgressAction.REMOVE)
                    }
                    break
            }
        }

        function navigateToMobility() {
            if(canContinue.value) {
                addStudentExchangePartner()
            }
        }

        return {
            toggle,
            ProgressToggle,
            signup,
            privacy,
            insurance,
            getLabels,
            getLoading,
            canContinue,
            navigateToMobility,
            getRedirectUrl,
            getErrorMessage,
            getStudyName
        }
    }
})
